import React from 'react';
import axios from 'axios';
import { Button, Icon, Table, Header, Segment, Form } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import {fetchAcademicYears, fetchSPSemesters, fetchStudyCycle} from "../../Lookups/util";

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class AverageGrade extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],

            academicYears: [],
            academicYear: null,
            academicYearErr: false,

            spSemesters: [],
            spSemester: null,
            spSemesterErr: false,

            studyCycles: [],
            studyCycle: null,
            studyCycleErr: false,


        };

        this.getStudents = this.getStudents.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        axios.all([fetchSPSemesters(), fetchAcademicYears(), fetchStudyCycle()])
            .then(axios.spread((spSemestersRes, academicYearsRes, studyCyclesRes) => {
                const spSemesters = spSemestersRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.studyYear
                }));

                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                const studyCycles = studyCyclesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                this.setState({
                    spSemesters, academicYears, studyCycles
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }


    getStudents() {

        if(!this.state.academicYear || !this.state.spSemester || !this.state.studyCycle){
            toast('Morate unijeti obavezna polja.');

            if(!this.state.academicYear){ this.setState({academicYearErr: true}) } else { this.setState({academicYearErr: false})}
            if(!this.state.spSemester){ this.setState({spSemesterErr: true}) } else { this.setState({spSemesterErr: false})}
            if(!this.state.studyCycle){ this.setState({studyCycleErr: true}) } else { this.setState({studyCycleErr: false})}
        }

        this.setState({academicYearErr: true, spSemesterErr: true, studyCycleErr: true});



        axios.put(`student-documents/request-cancellation/`)
            .then(res => {

            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <h1>  Prosjeci po godinama</h1>
            <Segment.Group raised >
                <Segment>
                    <Header as="h3">
                        Spisak studenata
                    </Header>
                </Segment>

                <Segment clearing>

                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown
                                    required
                                    label='Akademska godina'
                                    clearable
                                    selection
                                    placeholder="Odaberite akademsku godinu"
                                    value={this.state.academicYear}
                                    onChange={this.handleInputChange}
                                    name="academicYear"
                                    options={this.state.academicYears}
                                    search
                                    error={this.state.academicYearErr}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    required
                                    label='Godina studija'
                                    clearable
                                    selection
                                    placeholder="Odaberite godinu studija"
                                    value={this.state.spSemester}
                                    onChange={this.handleInputChange}
                                    name="spSemester"
                                    options={this.state.spSemesters}
                                    search
                                    error={this.state.spSemesterErr}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    required
                                    label='Ciklus studija'
                                    clearable
                                    selection
                                    placeholder="Odaberite ciklus studija"
                                    value={this.state.studyCycle}
                                    onChange={this.handleInputChange}
                                    name="studyCycle"
                                    options={this.state.studyCycles}
                                    search
                                    error={this.state.studyCycleErr}
                                />
                            </Form.Field>
                            <Form.Button label=" " color="blue" basic="true"  onClick={this.getStudents}>Prikaži</Form.Button>
                        </Form.Group>
                    </Form>
                </Segment>

                <Segment>

                    {this.state.data.length ?
                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Ime</Table.HeaderCell>
                                    <Table.HeaderCell>Prezime</Table.HeaderCell>
                                    <Table.HeaderCell>Prosjek</Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>  {this.props.data.map((el) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle">
                                        {el.firstName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.lastName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {}
                                    </Table.Cell >
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : 'Nema studenata na odabranoj godini'
                    }
                </Segment>
                <ToastContainer hideProgressBar />
            </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/AverageGrade.js